<template>
  <Modal :id="'cmp-settings-money-details-form'" @cancelled="onCancel" :loadingFlag="loadingFlag">
    <template slot="header"> {{title}} {{$t('money_details')}}</template>

    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'money_account_name'"
          v-bind="textFieldConfig"
          :value="money_account.money_account_name"
          :placeholder="$t('name')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'money_account_holder'"
          v-bind="textFieldConfig"
          :value="money_account.money_account_holder"
          :placeholder="$t('account_holder')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'account_no'"
          v-bind="textFieldConfig"
          :value="money_account.account_no"
          :placeholder="$t('account_no')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'bank_name'"
          v-bind="textFieldConfig"
          :value="money_account.bank_name"
          :placeholder="$t('bank_name')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'sort_code'"
          v-bind="textFieldConfig"
          :value="money_account.sort_code"
          :placeholder="$t('sortcode')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'swift'"
          v-bind="textFieldConfig"
          :value="money_account.swift"
          :placeholder="$t('bic_swift')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'iban'"
          v-bind="textFieldConfig"
          :value="money_account.iban"
          :placeholder="$t('iban')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'bank_address'"
          :height="142"
          :textarea="true"
          v-bind="textFieldConfig"
          :value="money_account.bank_address"
          :placeholder="$t('bank_address')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click.stop="onFormSubmit">{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@dtplugins/modal/modal';
import { createFormModalMixin, createFormItemMixin } from '../../../../dt-plugins/form-modal/form-modal';
import { AccountingSettingsService } from '../../services/accounting-settings.service';

export default {
  components: {
    Modal,
  },
  props: {

  },
  mixins: [
    createFormModalMixin(),
    createFormItemMixin({
      primary_key: 'money_account_id',
      itemKey: 'money_account',
      detailsHttpReq: AccountingSettingsService.findMoneyAccountDetails
    }),
  ],
  mounted: async function() {
    // if (this.isEditMode) {
    //   const itemDetails = await BookingSettingsService.findInvoiceItemDetails({
    //     money_account_id: this.money_account_id
    //   });
    //   console.log(itemDetails);
    //   this.money_account =  itemDetails.data.money_account;
    //   console.log("Log: this.money_account", this.money_account)
    // } else {
    //   this.money_account = this.getMoneyAccount();
    // }
  },
  computed: {
    // money_account_id: function() {
    //   return this.$route.query.money_account_id;
    // },
    // loadingFlag: function() {
    //   if (this.isEditMode) {
    //     return !this.money_account.money_account_id;
    //   } else {
    //     return this.submitted;
    //   }
    // },
  },
  methods: {
    // onFormSubmit: function() {
    //   this.submitted = true;

    //   this.$emit('done', {
    //     mode: this.mode,
    //     money_account: this.money_account
    //   });
    // },
    // onTextFieldValueChange: function(id, value) {
    //   this.money_account[id] = value;
    // },
    get_money_account: function() {
      return {
        swift: "",
        bank_name: "",
        account_no: "",
        money_account_name: "",
        bank_address: "",
        money_account_id: undefined,
        last_modified: "",
        money_account_holder: "",
        sort_code: "",
        iban: "",
      };
    }
    //MARK: Methods
  }
};



</script>

<style lang="scss">
.cmp-settings-money-details-form {
  .dt-checkbox-control {
    display: flex;
    padding-top: 12px;
    .dt-checkbox {
      max-width: 40px;
      margin: 3px 10px 0px 0px;
    }
  }
}
</style>
